module.exports = __webpack_public_path__ + "img/quotation-mark.61485734.svg";